import { useContext } from "react";
import { AppContext } from "../../app/store";

/** identical to `useContext(AppContext)` */
export const useAppContext = () => {
  const appContext = useContext(AppContext);
  return appContext;
};
